import axios from 'axios'
import axiosRetry from 'axios-retry'

const apileadsVirgilio = axios.create({
  baseURL: "https://virgilio.appengine.lucia.com.co/v1/procesar/",
  withCredentials: true,
  timeout: 600000,
  headers: {
    'Content-Type': 'application/json',
     'Authorization': 'd5395e2f-177d-4b6d-b231-5c03510801dd',
  },
})

axiosRetry(apileadsVirgilio, {
  retries: 5, // Número máximo de reintentos
  retryCondition: (error) => 
    // Reintenta solo si la respuesta es distinta de 200
     error.response && error.response.status !== 200
  ,
  retryDelay: axiosRetry.exponentialDelay, // Tiempo de espera entre reintentos
});

// apileads.interceptors.response.use(
//   response => {
//     const loginPage = window.location.pathname.indexOf('/') !== -1
//     if (response.status === 403 && loginPage) {
//       sessionStorage.setItem('userStatus', '')
//       window.location.href = '/'
//     }
//     return response
//   },
//   error => {
//     const loginPage = window.location.pathname.indexOf('/') !== -1
//     if (error.response.status === 403 && loginPage) {
//       sessionStorage.setItem('userStatus', '')
//       window.location.href = '/'
//     }
//     if (error.response.status === 500 && process.env.NODE_ENV !== 'development') {
//       sessionStorage.setItem('userStatus', '')
//       window.location.href = '/'
//     }
//     return Promise.reject(error)
//   }
// )

export { apileadsVirgilio }
